export default __webpack_public_path__ + "static/media/training-illustration25.721556b2.png";